import { Grid, useMediaQuery } from "@mui/material";
import { apiClient } from "api/apiClient";
import Euler from "assets/euler.png";
import { useLanguage } from "LanguageContext";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Box from "ReusableComponents/Box";
import MetaTags from "ReusableComponents/MetaTags/MetaTags";
import { COLORS } from "theme";
import { sortData } from "utils";
import AboutUsFeatures from "./AboutUsFeatures";
import AboutUsInfo from "./AboutUsInfo";
import Companies from "./Companies";
import AboutUsOverlay from "./components/AboutUsOverlay";
import ContactBanner from "./ContactBanner";
import OurTeam from "./OurTeam";
import Pronounciation from "./Pronounciation";
import TeamPics from "./TeamPics";

const AboutUs = () => {
  const small = useMediaQuery("(max-width: 600px)");
  const medium = useMediaQuery("(max-width: 900px)");
  const [pics, setPics] = useState([]);
  const [banner, setBanner] = useState([]);
  const [features, setFeatures] = useState([]);
  const [audio, setAuido] = useState([]);
  const [info, setInfo] = useState([]);
  const [headings, setHeading] = useState([]);
  const [text, setText] = useState([]);
  const [companies, setCompanies] = useState([]);
  const { selectedLanguage } = useLanguage();
  const { t } = useTranslation();

  useEffect(() => {
    apiClient.getTeams().then((res) => {
      setPics(res?.data);
    });
    apiClient.getInvestors().then((res) => {
      setCompanies(res?.data);
    });
    apiClient.getAboutUsBanner(selectedLanguage).then((res) => {
      setBanner(res?.data);
    });
    apiClient.getAboutUsFeatures(selectedLanguage).then((res) => {
      setFeatures(res?.data);
    });
    apiClient.getAboutUsInfo(selectedLanguage).then((res) => {
      setInfo(res?.data[0]);
    });
    apiClient.getAboutUsTabHeading(selectedLanguage).then((res) => {
      setHeading(sortData(res?.data));
    });
    apiClient.getAboutUsTabText(selectedLanguage).then((res) => {
      setText(sortData(res?.data));
    });
    apiClient.getAudio().then((res) => {
      setAuido(res?.data);
    });
  }, []);
  return (
    <>
      hi
      <Box position="relative" w="inherit">
        <AboutUsOverlay data={banner} small={small} />
        <Box h="540px">
          <img
            src={
              !small
                ? banner?.attributes?.banner?.data?.attributes?.url
                : banner?.attributes?.media_mobile?.data?.attributes?.url
            }
            alt={
              banner?.attributes?.media_mobile?.data?.attributes
                ?.alternativeText
            }
            style={{ width: "100%", height: "100%", maxWidth: "100%" }}
          />
        </Box>
      </Box>
      <Grid item xs={12} style={{ background: COLORS.lightBlack }}>
        <AboutUsInfo info={info} small={small} medium={medium} />
      </Grid>
      <Grid item xs={12} style={{ background: COLORS.lightBlack }}>
        <AboutUsFeatures features={features} small={small} medium={medium} />
      </Grid>
      <Grid item xs={12} style={{ paddingTop: "0" }}>
        <OurTeam
          small={small}
          medium={medium}
          headings={headings}
          text={text}
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{ paddingTop: "0", background: COLORS.lightBlack }}
      >
        <TeamPics pics={pics} small={small} />
      </Grid>
      <Grid
        item
        xs={12}
        style={{ paddingTop: "0", background: COLORS.lightBlack }}
      >
        <Pronounciation small={small} audio={audio} />
      </Grid>
      <Grid
        item
        xs={12}
        style={{ paddingTop: "0", background: COLORS.lightBlack }}
      >
        <Companies companies={companies} small={small} />
      </Grid>
      <Grid
        item
        xs={12}
        style={{ paddingTop: "0", background: COLORS.lightBlack }}
      >
        <ContactBanner small={small} />
      </Grid>
      <Helmet>
        <title>
          {t(
            "About Us - Best Electric Commercial Vehicle Company in India | Euler Motors"
          )}
        </title>
        <link rel="canonical" href="https://www.eulermotors.com/en/about-us" />
        <link rel="canonical" href="https://www.eulermotors.com/hi/about-us" />
        <link rel="canonical" href="https://www.eulermotors.com/ta/about-us" />
        <link rel="canonical" href="https://www.eulermotors.com/te/about-us" />
        <link rel="canonical" href="https://www.eulermotors.com/mr/about-us" />
        <link rel="canonical" href="https://www.eulermotors.com/gu/about-us" />
        <link rel="canonical" href="https://www.eulermotors.com/kn/about-us" />
        <link rel="canonical" href="https://www.eulermotors.com/bn/about-us" />
        <link rel="publisher" href="https://www.eulermotors.com/about-us" />
        <meta
          name="title"
          content={t(
            "About Us - Best Electric Commercial Vehicle Company in India | Euler Motors"
          )}
        />
        <meta
          name="description"
          content={t(
            "Euler Motors commercial EV OEM bringing solutions to the last mile delivery. Commercial EV's built for all businesses with our wide range of Delivery Vehicles."
          )}
        />
        ​
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.eulermotors.com/about-us"
        />
        <meta
          property="og:title"
          content="About us | Electric Commercial Vehicle Company in India | Euler Motors"
        />
        <meta
          property="og:description"
          content="Euler Motors is an electric commercial vehicle company in india bring solutions to the last mile delivery. Euler's vision is to provide Commercial EV's for all businesses with the widest range of Delivery Vehicles to drive sustainable electric mobility future."
        />
        <meta property="og:image" content={Euler} />
        ​
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://www.eulermotors.com/about-us"
        />
        <meta
          property="twitter:title"
          content="About us | Electric Commercial Vehicle Company in India | Euler Motors"
        />
        <meta
          property="twitter:description"
          content="Euler Motors is an electric commercial vehicle company in india bring solutions to the last mile delivery. Euler's vision is to provide Commercial EV's for all businesses with the widest range of Delivery Vehicles to drive sustainable electric mobility future."
        />
        <meta property="twitter:image" content={Euler} />
        <MetaTags link={"https://www.eulermotors.com/about-us"} />
      </Helmet>
    </>
  );
};

export default AboutUs;
